module.exports = __webpack_public_path__ + "static/media/banner_slider5.451fd313.jpg";